export default {
  loadImportEntriesSuccess: ({ importEntries }, payload) => {
    importEntries.pagination.totalItems = payload.recordsTotal;
    importEntries.pagination.deleted = false;
    importEntries.items = payload.data;
  },
  setImportDeleteStatus({ importEntries }, payload) {
    importEntries.pagination.deleted = payload.data.deleted;
  },
  closeErrorMessageSuccess({ importEntries }, payload) {
    importEntries.items[0].showErrorMessage = payload.data.status;
  },
  setPagination({ importEntries }, payload) {
    importEntries.pagination = payload;
  },
  setImportEntries({ importEntries }, payload) {
    importEntries.items = payload;
  },
  loadUnlinkedImportEntriesSuccess: ({ unlinkedImportEntries }, payload) => {
    unlinkedImportEntries.pagination.totalItems = payload.recordsTotal;
    unlinkedImportEntries.items = payload.data;
  },
  setUnlinkedPagination({ unlinkedImportEntries }, payload) {
    unlinkedImportEntries.pagination = payload;
  },
  loadUnlinkedReviewsSuccess: ({ unlinkedReviews }, payload) => {
    unlinkedReviews.pagination.totalItems = payload.recordsTotal;
    unlinkedReviews.items = payload.data;
  },
  setUnlinkedReviewsPagination({ unlinkedReviews }, payload) {
    unlinkedReviews.pagination = payload;
  },
  setImportForm({ importForm }, payload) {
    importForm.marketplaceId = payload.marketplaceId;
    importForm.sellerId = payload.sellerId;
    importForm.importExternalId = payload.importExternalId;
    importForm.region = payload.region;
    importForm.howManyReviews = payload.howManyReviews;
    importForm.howManyRatings = payload.howManyRatings;
    importForm.reviewStarSubset = payload.reviewStarSubset;
    importForm.translateReviews = payload.translateReviews;
    importForm.importOnlyWithImages = payload.importOnlyWithImages;
    importForm.importAllReviews = payload.importAllReviews;
    importForm.productId = payload.productId;
    importForm.importEntryId = payload.importEntryId;
    importForm.importRatings = payload.importRatings;
    importForm.minimumWords = payload.minimumWords;
    importForm.automaticSync = payload.automaticSync;
    importForm.autoApprove = payload.autoApprove;
    importForm.obfuscateReviewerName = payload.obfuscateReviewerName;
  },
  loadImportsTableSuccess: (state, payload) => {
    state.importsTable = payload;
    state.importEntries.pagination.totalItems = payload.length;
  },
};
